<template>
  <workflow-container ref="container" />
</template>

<script>
import { toolkitMixin } from '@/app/mixins/toolkit/item';
import WorkflowContainer from '@/app/modules/toolkit/pension/payment-instruction/modules/workflow/containers/workflow-container.vue';

export default {
  name: 'payment-instruction-item',
  mixins: [toolkitMixin],
  props: {
    uuid: {
      type: String,
      required: false,
    },
  },
  components: {
    WorkflowContainer,
  },
  async mounted() {
    if (this.$route.params.step) {
      this.$refs.container.handleStepChange(parseInt(this.$route.params.step, 10));
    }
  },
};
</script>

<style>

</style>
